<template>
  <div id="this-component">
    <div class="form-row">
      <div class="form-group col-md-3">
        <p class="text-left">
        <label for="ip">IP adresa</label>
        <input id="ip" type="text" class="form-control" placeholder="10.107.0.1" v-model="ipAddress">
        </p>
      </div>
      <div class="form-group col-md-3">
        <p class="text-left">
        <label for="u">uživatel</label>
        <input id="u" type="text" class="form-control" placeholder="admin" v-model="username">
        </p>
      </div>
      <div class="form-group col-md-3">
        <p class="text-left">
        <label for="p">heslo</label>
        <input id="p" type="password" class="form-control" placeholder="kleslo" v-model="password">
        </p>
      </div>
      <div class="form-group col-md-3">
        <p class="text-left">
          <label>
            <input type="checkbox" v-model="navostro"> na vostro!
          </label>
          <button class="btn btn-primary form-control" v-on:click="onClickButton()"
          :disabled="runningCommand !== undefined && exitStatus === undefined"
          >
            Jedem!
          </button>
        </p>
      </div>
    </div>
    <div class="form-row form-secondary-parameters">
      <div class="form-group col-md-3">
        <label>
          <input type="checkbox" v-model="checkboxKeepServiceApi"> nechat běžet IP/Services <b>api</b> a <b>api-ssl</b>
        </label>
        <label>
          <input type="checkbox" v-model="checkboxKeepServiceWww"> nechat běžet IP/Service <b>www</b>
        </label>
      </div>
      <div class="form-group col-md-3">
        <label>
          <input type="checkbox" v-model="checkboxRenameUser" v-on:change="checkboxRenameUserChange()"> přejmenovat uživatele na:
          <input type="text" :disabled="checkboxRenameUser == false" v-model="renameUserTo" class="form-control">
        </label>
        <label>
          <input type="checkbox" v-model="checkboxRemoveExtraUsers"> smazat všechny ostatní uživatele<span v-if="username"> než {{ username }}</span>
        </label>
      </div>
      <div class="form-group col-md-3">
        <label>
          <input type="checkbox" v-model="checkboxResetPassword"> nastavit nové náhodné heslo
        </label>
      </div>
    </div>
    <div class="alert alert-warning" role="alert" v-if="rsresource.scriptRunnerWs.readyState != 1">
      WS connecting ... ({{rsresource.scriptRunnerWs.url}})
    </div>

    <div class="alert alert-info" role="alert" v-if="scriptHelpUsage !== undefined">
      <pre>{{scriptHelpUsage}}</pre>
    </div>
    <div class="alert alert-dark" role="alert" v-if="runningCommand !== undefined" id="running-command">
      <div style="float: right;">
        <div class="spinner" v-if="exitStatus === undefined"></div>
        <div class="green_circle text-success" v-if="exitStatus === 0">✔</div>
        <div class="red_circle text-danger" v-if="exitStatus > 0"><b>!</b></div>
      </div>
      <div>
        <small>
        <pre>{{runningCommand}}</pre>
        </small>
      </div>
    </div>
    <div class="alert" role="alert" v-if="stdout != ''"
      :class="{ 'alert-dark': exitStatus === undefined, 'alert-danger': exitStatus > 0, 'alert-success': exitStatus === 0}"
    >
      <samp>
        <pre>{{ stdout }}</pre>
      </samp>
      <p class="text-left" style="margin:0;" v-if="exitStatus === undefined">
        <span class="blinking-cursor"></span>
      </p>
    </div>
  </div>
</template>

<script>

class RosScriptResource {
  runUpgraderScript (ipAddress, username, password, parameters) {
    this.scriptRunnerWs.send(JSON.stringify({command: 'run', ip: ipAddress, u: username, p: password, params: parameters}))
  }
  usageOfUpgraderScript () {
    this.scriptRunnerWs.send(JSON.stringify({command: 'usage'}))
  }

  wsUrl = 'ws://' + window.location.host + window.location.pathname + 'ws/script-runner';

  openRunnerWebsocket (incomingLineHandler, connectionStateHandler) {
    this.scriptRunnerWs = new WebSocket(this.wsUrl)
    this.scriptRunnerWs.onmessage = function (evt) {
      incomingLineHandler(evt.data)
    }
    this.scriptRunnerWs.onclose = (event) => {
      console.log('scriptRunnerWs WS Closed - code: ' + event.code + ', reason: ' + event.reason + ', wasClean: ' + event.wasClean)
      connectionStateHandler()
      setTimeout(() => { this.openRunnerWebsocket(incomingLineHandler, connectionStateHandler) }, 1000) // automatic reconnect
    }
    this.scriptRunnerWs.onopen = () => {
      console.log('scriptRunnerWs ', this.wsUrl, 'connected...')
      this.scriptRunnerWs.send('This is script runner client from ' + navigator.userAgent)
      connectionStateHandler()
    }
  }
}

export default {
  name: 'OneOff',
  data () {
    return {
      ipAddress: '10.107.0.1',
      username: 'admin',
      password: '',
      navostro: false,
      checkboxKeepServiceApi: false,
      checkboxKeepServiceWww: false,
      checkboxRenameUser: false,
      renameUserTo: undefined,
      checkboxRemoveExtraUsers: false,
      checkboxResetPassword: true,

      rsresource: new RosScriptResource(),
      runningCommand: undefined,
      stdout: '',
      exitStatus: undefined,
      firstWsConnection: true,
      scriptHelpUsage: undefined
    }
  },
  created: function () {
    this.rsresource.openRunnerWebsocket(this.onWsMessage, this.connectionStateHandler)
  },

  methods: {
    onClickButton: function () {
      this.rsresource.runUpgraderScript(this.ipAddress, this.username, this.password, {
        navostro: this.navostro,
        keepServiceApi: this.checkboxKeepServiceApi,
        keepServiceWww: this.checkboxKeepServiceWww,
        renameUserTo: this.checkboxRenameUser ? this.renameUserTo : undefined,
        removeExtraUsers: this.checkboxRemoveExtraUsers,
        resetPassword: this.checkboxResetPassword
      })
      this.scriptHelpUsage = undefined
    },

    onWsMessage: function (receivedMessage) {
      // console.log('From WS:' + receivedMessage)
      let receivedJson = JSON.parse(receivedMessage)
      if (receivedJson.what === 'stdout') {
        this.stdout = this.stdout + receivedJson.text
      }
      if (receivedJson.what === 'started') {
        this.stdout = ''
        this.exitStatus = undefined
        this.runningCommand = receivedJson.command
      }
      if (receivedJson.what === 'finished') {
        this.exitStatus = receivedJson.exitStatus
      }
      if (receivedJson.what === 'usage') {
        this.scriptHelpUsage = receivedJson.usage
      }
    },

    connectionStateHandler: function () {
      this.$forceUpdate()
      if (this.firstWsConnection) {
        // beh naprazdno - zobrazi --help
        this.rsresource.usageOfUpgraderScript()
      }
      this.firstWsConnection = false
    },

    checkboxRenameUserChange: function () {
      if (this.checkboxRenameUser === false) {
        this.renameUserTo = undefined
      }
    }
  } // methods
}
</script>

<style scoped>
.alert {
  text-align: left;
}
.form-row {
  text-align: left;
}
.form-group, .form-group p {
  margin-bottom: 0.25em;
}
.form-secondary-parameters {
  font-size: 75%;
}
#this-component {
  margin: 1em;
}
samp {
  text-align: left;
}
#running-command {
  text-align: left;
  background-color: transparent;
}
pre {
  margin-bottom: 0;
  white-space: pre-wrap;
}
p.text-left label {
  margin-left: 0.3em;
}
.green_circle {
  width:24px;
  height:24px;
  border-radius:12px;
  border: 1px solid #28a745!important;
  text-align: center;
}
.red_circle {
  width:24px;
  height:24px;
  border-radius:12px;
  border: 1px solid #dc3545!important;
  text-align: center;
}

.blinking-cursor {
  font-size: 20px;
  padding-right: 20px;
  display: inline-block;
}

.blinking-cursor:after {
  content: '';
  width: 2px;
  height: 1em;
  background:green;
  opacity: 0;
  display: inline-block;
  animation: blink 0.75s linear infinite alternate;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  45% {
    opacity: 0;
  }
  55% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}

</style>
<style src="../assets/spinner.css"></style>



// WEBPACK FOOTER //
// src/components/OneOff.vue